<template>
  <div class="page">
    <div class="Booktitle">花生宠物证书生成</div>
    <div class="Box">
      <div class="BookContent">
        <div class="BookList">
          <div class="BookListName">品种：</div>
          <el-input
            v-model="petMsg.categoryInfo.name"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <div class="BookList">
          <div class="BookListName">性别：</div>
          <el-input v-model="petMsg.petSex" placeholder="请输入内容"></el-input>
        </div>
        <div class="BookList">
          <div class="BookListName">颜色：</div>
          <el-input
            v-model="petMsg.petColor"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <div class="BookList">
          <div class="BookListName">主人：</div>
          <el-input v-model="name" placeholder="请输入宠物主姓名"></el-input>
        </div>
        <div class="BookList">
          <div class="BookListName">身份证：</div>
          <el-input
            v-model="idNo"
            placeholder="请输入宠物主身份证号"
          ></el-input>
        </div>
      </div>
      <div class="BookContent">
        <div class="BookList">
          <div class="BookListName">出生日期:</div>
          <el-input v-model="petMsg.age" placeholder="请输入内容"></el-input>
        </div>
        <div class="BookList">
          <div class="BookListName">登记地点：</div>
          <el-input
            v-model="petMsg.feedShop.name"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <div class="BookList">
          <div class="BookListName">注册时间：</div>
          <el-input v-model="takeTime" placeholder="请输入内容"></el-input>
        </div>
        <div class="BookList">
          <div class="BookListName">芯片编号：</div>
          <el-input
            v-model="petMsg.epromNo"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <div class="BookList">
          <div class="BookListName">证书编号：</div>
          <el-input
            v-model="petMsg.insideNo"
            placeholder="请输入内容"
          ></el-input>
        </div>
        <div class="btn1" @click="handleSunmitClick">证书生成</div>
      </div>
    </div>

    <div v-if="imgbook">
      <div class="Booktitle">我的证书</div>
      <a :href="imgbook" target="_blank" download>
        <el-button class="btn2" size="small" type="primary">下载证书</el-button>
      </a>
      <!-- <div >下载证书</div> -->
      <div class="myBook">
        <img :src="imgbook" alt="" style="width: 100%; height: 100%" />
      </div>
    </div>
  </div>
</template>

<script>
import { updateBook } from "../../../api/purchaseApi.js";
export default {
  data() {
    return {
      takeTime: this.$public.FTime(this.petMsg.takeTime, "YYYY-MM-DD"),
      systemDate: this.$moment().format("YYYY-MM-DD"), //注册时间
      idNo: "", //身份证号
      name: "", //主人名字
      imgbook: "",
      url: "",
    };
  },
  props: {
    id: {
      default: "",
    },
    petMsg: {
      default: "",
    },
    // 身份证号 证书照片 名字
    certificateImage: {
      default: "",
    },
    buyPetMemberRealName: {
      default: "",
    },
    buyPetMemberIdNO: {
      default: "",
    },
  },
  mounted() {
    // console.log("证书", this.certificateImage);
    if (this.certificateImage) {
      this.imgbook = this.certificateImage;
    }
    if (this.buyPetMemberRealName) {
      this.name = this.buyPetMemberRealName;
    }
    if (this.buyPetMemberIdNO) {
      this.idNo = this.buyPetMemberIdNO;
    }
  },
  methods: {
    //提交
    handleSunmitClick() {
      if (!this.name) {
        this.$message.error("请输入宠物主姓名");
        return;
      }

      if (!this.idNo) {
        this.$message.error("请输入宠物主身份证号");
        return;
      }
      console.log("12", this.idNo.length !== 18);
      if (this.idNo.length !== 18) {
        this.$message.error("请输入正确的宠物主身份证号");
        return;
      }
      let params = {
        petId: this.id,
        idNo: this.idNo,
        name: this.name,
      };
      // console.log("提交信息", params);
      let loading = this.$loading();
      updateBook(params).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.imgbook = "";
          console.log("提交信息", res.data.url);
          this.imgbook = res.data.url;
          this.$message({
            type: "success",
            message: "已生成证书",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  min-height: 734px;
  background: #fff;
  margin-top: 12px;
  font-size: 30px;
  .Booktitle {
    margin-left: 20px;
    font-size: 15px;
    line-height: 60px;
    font-weight: 600;
    border: 1px solid rgb(194, 193, 193);
    border-left: none;
    border-right: none;
  }
  .Box {
    padding: 40px 80px;
    display: flex;
    justify-content: space-between;
  }
  .BookList {
    display: flex;
    align-items: center;
    margin: 20px 0px;
    .BookListName {
      font-size: 16px;
      margin-right: 20px;
      width: 80px;
      text-align: right;
      // background: red;
    }
    .el-input {
      width: 300px !important;
      float: left !important;
    }
  }
  .btn1 {
    width: 98px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: linear-gradient(135deg, #5685ff 0%, #3569ff 100%);
    border-radius: 10px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    cursor: pointer;
    float: right;
    margin-bottom: 20px;
  }
  .myBook {
    width: 60%;
    height: 500px;
    // border: 1px solid rgb(155, 152, 152);
    margin: 30px auto;
    border-radius: 15px;
  }
  .btn2 {
    width: 98px;
    line-height: 40px;
    text-align: center;
    background: linear-gradient(135deg, #5685ff 0%, #3569ff 100%);
    border-radius: 10px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    cursor: pointer;
    margin-right: 80px;
    float: right;
    margin-top: 20px;
  }
}
</style>